module.exports = __webpack_public_path__ + "static/media/2_pl.83a59e02.png";